// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603310804/js/" + chunkId + "." + {"44":"0b2bd6c9","225":"6baf7e1d","481":"d5414d16","486":"23b617bb","770":"a61084f7"}[chunkId] + ".0.7507606906860602.chunk.js";
};